<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* background-color: blue; */
  /* margin-top: 60px; */
  width: 100%;
  height: 100%;
  /* margin-left: -15px;
  margin-top: -7px; */
  
}
/* 预览图片css */
.vpClass .ant-modal-confirm-btns {
  display: none !important;
}
.vpClass .anticon-check-circle {
  display: none !important;
}
.vpClass .ant-modal-content {
  background-color: inherit !important;
}
.vpClass .ant-modal-confirm-content {
  display: flex !important;
  justify-content: center !important;
}
.vpClass .ant-modal-close {
  display: block !important;
  color: #8a8a8a !important;
}
.vpClass .ant-modal-close-x {
  width: 25px !important;
  height: 25px !important;
  line-height: 25px !important;
  background: #ffffff !important;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue